import React, {useEffect, useState} from 'react';
import {Button, Col, Form} from "react-bootstrap";
import IconViewCards from '../images/icon_view_cards.png';
import IconViewList from '../images/icon_view_list.png';
import IconViewMap from '../images/icon_view_map.png';

const ListViewSelector = props => {

  const { viewStyleCallback, selected } = props;
  const [chosenView, setChosenView] = useState()

  const changeView = viewChoice => {
    viewStyleCallback(viewChoice);
    setChosenView(viewChoice);
  }

  useEffect(() => {
    setChosenView(selected);
  }, [selected]);

  return (
    <Form.Group>
      <Form.Label>{props.label}</Form.Label>
        <div className="list-view-selector">
          <Form.Row>
            <Col>
              <Button href="#"
                      aria-label="View as Cards"
                      variant='link'
                      onClick={() => changeView('cards')}
                      className={chosenView === 'cards' ? 'selected' : ''}
              ><img src={IconViewCards} alt="View as Cards"/></Button>
            </Col>
            <Col className="list-view-selector-list">
              <Button href="#"
                      aria-label="View as List"
                      variant='link'
                      onClick={() => changeView('list')}
                      className={chosenView === 'list' ? 'selected' : ''}
              ><img src={IconViewList} alt="View as List"/></Button>
            </Col>
            <Col>
              <Button href="#"
                      aria-label="View as Map"
                      variant='link'
                      onClick={() => changeView('map')}
                      className={chosenView === 'map' ? 'selected' : ''}
              ><img src={IconViewMap} alt="View as Map"/></Button>
            </Col>
          </Form.Row>
        </div>
    </Form.Group>
  )
}

export default ListViewSelector;
